import React from "react";
import { connect } from "react-redux";
import Card from "../../../../shared/Card/Card";
import UploadFile from "../../../../shared/UploadFile/UploadFile";
import Checkbox from "../../../../shared/Checkbox/Checkbox";
import Button from "../../../../shared/button/button";
import { bindActionCreators } from "redux";
import AdvancedManagementScannedStatement from "./../template/AdvancedManagementScannedStatement";
import AdvancedManagementDocumentsScannedStatement from "./../template/AdvancedManagementDocumentsScannedStatement";
import {
	setStep,
	setDataToStoreDocuments,
	onSendingFile
} from "../../../actions/advanced-management";
import Loading from "../../../../shared/Loading/Loading";
import axios from "axios";
import { getUploadFileURL } from "../../../shared/multi-accounts-requests-api";

class AdvancedManagementSendDocuments extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			documents: {},
			signedUrls: [],
			isFrontAndBack: false,
			idFrontFile: undefined,
			idBackFile: undefined,
			selfieFile: undefined,
			declarationFile: undefined
		};
		this.sendFile = this.sendFile.bind(this);
	}

	componentDidMount() {
		const { data } = this.props;
		let self = this;
		getUploadFileURL(data.relationId).then(response => {
			self.setState({ signedUrls: response.data });
		});
	}

	isValidToNext = () => {
		const {
			isFrontAndBack,
			idFront,
			idFrontFile,
			idBackFile,
			selfieFile,
			declarationFile,
			idBack,
			selfie,
			declaration
		} = this.state;
		return (
			idFront &&
			idFrontFile &&
			(frontAndBack || (idBack && idBackFile)) &&
			selfie &&
			selfieFile &&
			declaration &&
			declarationFile
		);
	};

	dataURLtoFile(dataurl, filename) {
		let arr = dataurl.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, { type: mime });
	}

	sendFile(signedUrl, file) {
		const self = this;
		// Put the fileType in the headers for the upload
		const options = {
			headers: {
				"Content-Type": "image/png"
			}
		};
		axios
			.put(signedUrl, file, options)
			.then(result => {
				self.props.onSendingFile(-1);
			})
			.catch(error => {
				// alert("ERROR " + JSON.stringify(error)); //remover
				location.reload();
			});
	}

	onChange = (type, file) => {
		const { signedUrls } = this.state;
		let self = this;
		let dataurl = "";
		let signedUrl = signedUrls.find(sUrl => sUrl.type == type);

		let reader = new FileReader();
		reader.onload = e => {
			let img = document.createElement("img");
			img.onload = () => {
				let canvas = document.createElement("canvas");
				let ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0);

				let MAX_WIDTH = 800;
				let MAX_HEIGHT = 800;
				let width = img.width;
				let height = img.height;

				if (width > height) {
					if (width > MAX_WIDTH) {
						height *= MAX_WIDTH / width;
						width = MAX_WIDTH;
					}
				} else {
					if (height > MAX_HEIGHT) {
						width *= MAX_HEIGHT / height;
						height = MAX_HEIGHT;
					}
				}
				canvas.width = width;
				canvas.height = height;
				ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0, width, height);
				dataurl = canvas.toDataURL("image/png");
				let correctFile = self.dataURLtoFile(dataurl, type + ".png");
				self.sendFile(signedUrl.url, correctFile);
			};
			img.src = e.target.result;
		};
		if (file) {
			reader.readAsDataURL(file);
			this.props.onSendingFile(1);
		}

		this.setState({
			[type + "File"]: file,
			[type]: {
				type,
				key: signedUrl.key
			}
		});

		return {
			type,
			key: signedUrl.key
		};
	};

	checkDocuments = () => {
		const {
			isFrontAndBack,
			idFront,
			idBack,
			selfie,
			declaration,
			idFrontFile,
			idBackFile,
			selfieFile,
			declarationFile
		} = this.state;
		let personalDocuments = !!isFrontAndBack
			? !!isFrontAndBack
			: !!idFront && idFrontFile && (!!idBack && idBackFile) ? true : false;
		return personalDocuments && (!!selfie && selfieFile) && (declaration && declarationFile)
			? false
			: true;
	};

	onSave = () => {
		const { isFrontAndBack, idFront, idFrontFile, selfie, declaration } = this.state;
		const { hasIdFront, hasIdBack, hasSelfie } = this.props.hasDocuments;
		let idBack = this.state.idBack;
		let docs = [];

		if (isFrontAndBack) {
			idBack = this.onChange("idBack", idFrontFile);
		}

		if (hasIdFront && hasIdBack && hasSelfie) {
			docs = [declaration];
		} else {
			docs = [idFront, idBack, selfie, declaration];
		}

		this.props.setDataToStoreDocuments({
			docs: docs
		});

		this.props.setStep(4);
	};

	onCancel = () => {
		this.props.setStep(1);
	};

	setFrontAndBack = event => {
		this.setState({
			isFrontAndBack: event[0].checked,
			idBackFile: undefined
		});
	};

	render() {
		const { hasIdFront, hasIdBack, hasSelfie } = this.props.hasDocuments;
		return (
			<div className="advanced-management-send-documents">
				{hasIdFront && hasIdBack && hasSelfie ? (
					<AdvancedManagementScannedStatement
						documents={this.state}
						onSave={this.onSave}
						ifShow={true}
						onChange={this.onChange}
						onCancel={this.onCancel}
					/>
				) : (
					<AdvancedManagementDocumentsScannedStatement
						setFrontAndBack={this.setFrontAndBack}
						isFrontAndBack={this.state.isFrontAndBack}
						documents={this.state}
						onSave={this.onSave}
						ifShow={true}
						onChange={this.onChange}
						onCancel={this.onCancel}
						checkDocuments={this.checkDocuments}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	...state.advancedManagement,
	data: state.advancedManagement.dataToSendDocuments
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setStep,
			setDataToStoreDocuments,
			onSendingFile
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedManagementSendDocuments);
